var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_28890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.676 0.988526L0.989383 21.6581C-0.122763 22.7693 -0.122763 24.5642 0.989383 25.6754L21.676 46.345C22.7881 47.4562 24.5844 47.4562 25.6966 46.345L34.3702 37.6785C35.3662 36.6833 35.3662 35.0698 34.3702 34.0746C33.3741 33.0794 31.7593 33.0794 30.7633 34.0746L24.1879 40.6446C23.9111 40.9212 23.491 40.9212 23.2142 40.6446L6.69446 24.1385C6.41764 23.8619 6.41764 23.4421 6.69446 23.1655L23.2142 6.65938C23.491 6.3828 23.9111 6.3828 24.1879 6.65938L30.7633 13.2294C31.7593 14.2245 33.3741 14.2245 34.3702 13.2294C35.3662 12.2342 35.3662 10.6206 34.3702 9.62546L25.6975 0.959941C24.5808 -0.127243 22.7838 -0.118441 21.676 0.988526Z",
    fill: "url(#paint0_linear_6_28890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.676 0.988526L0.989383 21.6581C-0.122763 22.7693 -0.122763 24.5642 0.989383 25.6754L21.676 46.345C22.7881 47.4562 24.5844 47.4562 25.6966 46.345L34.3702 37.6785C35.3662 36.6833 35.3662 35.0698 34.3702 34.0746C33.3741 33.0794 31.7593 33.0794 30.7633 34.0746L24.1879 40.6446C23.9111 40.9212 23.491 40.9212 23.2142 40.6446L6.69446 24.1385C6.41764 23.8619 6.41764 23.4421 6.69446 23.1655L23.2142 6.65938C23.9034 6.06518 25.028 4.86165 26.6795 4.58016C27.9068 4.37097 29.2486 4.8314 30.7049 5.96146C29.7313 4.98864 28.0622 3.32147 25.6975 0.959941C24.5808 -0.127243 22.7838 -0.118441 21.676 0.988526Z",
    fill: "url(#paint1_linear_6_28890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.372 32.1525C37.368 33.1477 38.9829 33.1477 39.9789 32.1525L46.377 25.7597C47.4891 24.6484 47.4891 22.8536 46.3771 21.7425L39.9232 15.3168C38.9249 14.3228 37.3095 14.3243 36.3129 15.32C35.3169 16.3152 35.3169 17.9287 36.3129 18.9239L40.6719 23.2793C40.9487 23.5559 40.9487 23.9757 40.6719 24.2523L36.372 28.5486C35.376 29.5438 35.376 31.1573 36.372 32.1525Z",
    fill: "url(#paint2_linear_6_28890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7895 29.351C26.8742 29.351 29.3748 26.8524 29.3748 23.7702C29.3748 20.6881 26.8742 18.1895 23.7895 18.1895C20.7048 18.1895 18.2041 20.6881 18.2041 23.7702C18.2041 26.8524 20.7048 29.351 23.7895 29.351Z",
    fill: "url(#paint3_linear_6_28890)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_28890",
    x1: 21.8674,
    y1: 0.151368,
    x2: 41.5257,
    y2: 12.1564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_28890",
    x1: 24.5042,
    y1: 0.151367,
    x2: 14.7948,
    y2: 50.3321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378601,
    stopColor: "#148EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A60FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_28890",
    x1: 43.6815,
    y1: 12.1945,
    x2: 31.0481,
    y2: 31.9521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA816E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414726,
    stopColor: "#F74A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F51D2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_28890",
    x1: 25.8145,
    y1: 14.2058,
    x2: 21.611,
    y2: 31.0205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512635,
    stopColor: "#F74A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F51D2C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_28890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.3333,
    height: 47.3333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo_sm.4e01f1bc14db58a61805b5095ec72e52.svg";
export { ForwardRef as ReactComponent };